import Box from "./Box";
import React from "react";

function FilterMenuSection({ children }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={[20, null, 30, null]}
    >
      {children}
    </Box>
  );
}

export default FilterMenuSection;
